
  <div
  (click)="cta ? null : navigateTo(linkTarget, queryParams, state)"
  class="banner-default"
  [class.pointer]="!cta"
  [ngStyle]="{ 'background-image': 'url(' + (isMobile ? bannermobile : banner) + ')' }">

  <div class="content">
    <h3 class="title" *ngIf="title" [innerHTML]="title"></h3>
    <div class="description">
      <p class="sub-title" *ngIf="subtitle" [innerHTML]="subtitle"></p>
      <p class="lead" *ngIf="lead" [innerHTML]="lead"></p>
      <a
        *ngIf="link && cta"
        mat-button
        theme="white-pink-outline"
        [href]="link"
        class="unh-button-old"
      >
      <!-- colocar no modo normal: target="_blank" -->

        {{ linktext }}
      </a>
    </div>
  </div>

  <div
    class="get-pro"
    *ngIf="!isSubscribed && enabledGetPro">
    <img
      src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/background/text-acesso-ilimitado-right.png"
      alt=""
    />
    <p>a partir de R$ 44/mês
      <span>*no plano anual</span>
    </p>
  </div>

  <div class="side-mask" *ngIf="!isSubscribed && enabledGetPro"></div>
</div>
